import { useSearchParams } from "react-router-dom";
import { useConfigShowQuery } from "@/admin/entities/configs";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

export function useConfigsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  useConfigShowQuery(id, id === null);

  return {
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,
    getTableData,
    texts: getTextsConfig(),
  };
}
